import { render, staticRenderFns } from "./GenerationCard.vue?vue&type=template&id=44986d6d"
import script from "./GenerationCard.vue?vue&type=script&lang=js"
export * from "./GenerationCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports